import React from 'react'; // Force HMR
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from './config/sentry'
import './index.css'
import 'survey-core/survey-core.min.css'
import './styles/survey-theme.css'
import './i18n' // Add this for localization
import { setupToastInterceptor } from './lib/i18n/toastInterceptor'
import { ThemeProvider } from './context/ThemeContext'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import SentryErrorBoundary from './components/common/SentryErrorBoundary'

initSentry();
setupToastInterceptor();

// تفعيل وحدة تحكم المطور على الأجهزة المحمولة (Eruda)
// يتم حظرها تلقائياً في بيئتي التجارب والإنتاج (staging & production)
// ولا يتم تفعيلها إلا في بيئة التطوير المحلية (localhost) أو بطلب صريح عبر الرابط (?eruda=true)
const isLocalHost = Boolean(
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
   window.location.hostname === '127.0.0.1' ||
   window.location.hostname === '[::1]')
);

const isExplicitlyRequested = Boolean(
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).get('eruda') === 'true'
);

if (isExplicitlyRequested || (isLocalHost && import.meta.env.DEV)) {
  import('eruda').then(({ default: eruda }) => {
    eruda.init();
  }).catch((err) => {
    console.warn('Failed to load Eruda:', err);
  });
}

import { hasMsalAuthResponse, handleMsalPopupBridge } from './lib/auth/microsoftAuth';

if (hasMsalAuthResponse()) {
  void handleMsalPopupBridge();
  const rootEl = document.getElementById('root');
  if (rootEl) {
    rootEl.innerHTML = `
      <div style="font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; background: #0b1120; color: #f8fafc; text-align: center; padding: 24px; box-sizing: border-box;" dir="rtl">
        <div style="width: 52px; height: 52px; border-radius: 50%; background: #1e293b; display: flex; align-items: center; justify-content: center; margin-bottom: 16px; font-size: 24px; color: #38bdf8;">✓</div>
        <h2 style="margin: 0 0 8px 0; font-size: 18px; font-weight: 600;">تم تسجيل الدخول بنجاح</h2>
        <p style="margin: 0 0 20px 0; font-size: 14px; color: #94a3b8;">جاري إغلاق هذه النافذة والعودة للمنصة...</p>
        <button onclick="window.close()" style="background: #2563eb; color: #ffffff; border: none; border-radius: 9999px; padding: 10px 24px; font-size: 14px; font-weight: 500; cursor: pointer;">إغلاق النافذة</button>
      </div>
    `;
  }
} else {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <SentryErrorBoundary>
        <BrowserRouter>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </SentryErrorBoundary>
    </StrictMode>,
  );
}
